import validator from 'validator';
import lodashIsEqual from 'lodash/isEqual';

export const isEmail = validator.isEmail;
export const isNumeric = validator.isNumeric;
export const isEqual = lodashIsEqual;

/**
 * Check if a required value is not empty
 */
export function isEmpty(value: unknown): boolean {
  if (value === undefined) return true;
  if (value === null) return true;

  // if the value is a string it should not be empty
  if (isString(value)) {
    return validator.isEmpty(value as string);
  } else if (isNumber(value)) {
    return false;
  }

  return false;
}

/**
 * Check if a number is bigger or equal than the minimum allowed.
 */
export function minValue(value: number, min: number): boolean {
  return !isNaN(value) && value >= min;
}

/**
 * Check if a number is smaller or equal than the maximum allowed.
 */
export function maxValue(value: number, max: number): boolean {
  return !isNaN(value) && value <= max;
}

/**
 * Check if a number is bigger  than the minimum allowed.
 */
export function minValueExclusive(value: number, min: number): boolean {
  return !isNaN(value) && value > min;
}

/**
 * Check if a number is smaller or equal than the maximum allowed.
 */
export function maxValueExclusive(value: number, max: number): boolean {
  return !isNaN(value) && value < max;
}

/**
 * Check if a string has at least a certain amount of characters.
 */
export function minLength(value: string, min: number): boolean {
  return value && value.length < min;
}

/**
 * Check if a string has at least a certain amount of characters.
 */
export function maxLength(value: string, max: number): boolean {
  return value && value.length > max;
}

/**
 * Check if the value is a string
 */
export function isString(value: string | number | unknown): boolean {
  return typeof value === 'string';
}

/**
 * Check if the value is a number
 */
export function isNumber(value: string | number | unknown): boolean {
  return typeof value === 'number' && !isNaN(value);
}
